import Swal from "sweetalert2";
import WarningVector from "../../../../../assets/icons/WarningVector.svg";

const ModalAgreementPotentialClaim = ({ onAgree, onDisagree }) => {
  let agreementChecked = false;

  Swal.fire({
    position: "center",
    heightAuto: false,
    width: 680,
    padding: "24px",
    showConfirmButton: false,
    showCloseButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    background: "#FFFFFF",

    customClass: {
      container: "claim-agreement-container",
      popup: "claim-agreement-popup",
    },
    html: `
      <div style="text-align: left;">
        <div style="display:flex; align-items:center; gap:12px; margin-bottom:16px;">
          <img src="${WarningVector}" width="26px" height="26px" />
          <h2
            style="
              margin:0;
              font-size:20px;
              font-weight:700;
              color:#111827;
              line-height:1.3;
            "
          >
            Pernyataan Penting Sebelum Melakukan Klaim
          </h2>
        </div>
        <div
          style="
            color:#4B5563;
            font-size:14px;
            line-height:1.6;
          "
        >
          <p style="margin-bottom:12px;">
            Data yang ditampilkan dalam fitur ini bersumber dari sistem dan dapat mencakup data milik pengguna lain.
            Dengan melakukan klaim, Anda menyatakan dan menjamin bahwa:
          </p>
          <ol style="padding-left:20px; margin-bottom:14px; display:flex; flex-direction:column; gap:4px;">
            <li>
              Data yang Anda klaim adalah benar-benar milik Anda atau Anda memiliki hak yang sah atas data tersebut.
            </li>
            <li>
              Anda tidak mengklaim data yang Anda ketahui atau patut diduga merupakan milik pihak lain.
            </li>
            <li>
              Seluruh informasi yang Anda berikan dalam proses klaim adalah benar, akurat, dan dapat dipertanggungjawabkan.
            </li>
          </ol>
          <p style="margin-bottom:18px; font-size:13px; color:#6B7280;">
            Penyalahgunaan fitur ini, termasuk klaim atas data yang bukan milik Anda,
            merupakan pelanggaran terhadap Syarat & Ketentuan Layanan dan dapat
            berakibat pada penangguhan akun, pembatalan klaim, serta tindakan hukum
            sesuai peraturan yang berlaku.
            Sistem kami memiliki mekanisme validasi dan audit untuk mendeteksi klaim
            yang tidak sah. Apabila ditemukan ketidaksesuaian, hak penggunaan fitur
            klaim dapat dicabut sewaktu-waktu.
          </p>
        </div>
        <label
          style="
            display:flex;
            align-items:flex-start;
            gap:10px;
            margin-bottom:24px;
            cursor:pointer;
          "
        >
          <input
            id="agreement-checkbox"
            type="checkbox"
            style="
              width:16px;
              height:16px;
              margin-top:2px;
              cursor:pointer;
            "
          />
          <span
            style="
              font-size:13.5px;
              color:#4B5563;
              font-style:italic;
            "
          >
            Saya telah membaca, memahami, dan menyetujui pernyataan di atas.
          </span>
        </label>
        <div
          style="
            display:flex;
            justify-content:space-between;
            gap:16px;
          "
        >
          <button
            id="btn-disagree"
            style="
              flex:1;
              height:44px;
              border:none;
              border-radius:8px;
              background:#E25745;
              color:white;
              font-size:14px;
              font-weight:600;
              cursor:pointer;
            "
          >
            TIDAK SETUJU
          </button>
          <button
            id="btn-agree"
            disabled
            style="
              flex:1;
              height:44px;
              border:none;
              border-radius:8px;
              background:#B8BDC7;
              color:white;
              font-size:14px;
              font-weight:600;
              cursor:not-allowed;
            "
          >
            LANJUTKAN PROSES KLAIM
          </button>
        </div>
      </div>
    `,

    didOpen: () => {
      const container = Swal.getContainer();
      const popup = Swal.getPopup();

      if (container) {
        container.style.display = "flex";
        container.style.alignItems = "center";
        container.style.justifyContent = "center";
      }

      if (popup) {
        popup.style.margin = "auto";
        popup.style.borderRadius = "12px";
      }

      const checkbox = document.getElementById("agreement-checkbox");

      const agreeBtn = document.getElementById("btn-agree");

      const disagreeBtn = document.getElementById("btn-disagree");

      checkbox.addEventListener("change", e => {
        agreementChecked = e.target.checked;

        agreeBtn.disabled = !agreementChecked;

        agreeBtn.style.background = agreementChecked ? "#2563EB" : "#B8BDC7";

        agreeBtn.style.cursor = agreementChecked ? "pointer" : "not-allowed";
      });

      agreeBtn.addEventListener("click", () => {
        if (!agreementChecked) return;
        if (onAgree) {
          onAgree().then(() => Swal.close());
        }
      });

      disagreeBtn.addEventListener("click", () => {
        Swal.close();
        if (onDisagree) {
          onDisagree();
        }
      });
    },
  });
};

export default ModalAgreementPotentialClaim;
